import { Modal, Select, SelectOptionType } from '@bp/ui-components';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MultiValue } from 'react-select';
import { ModalBottomButtons } from '../../ModalBottomButtons/ModalBottomButtons';

type DuplicateAvailabilityModalProps = {
  isOpen: boolean;
  onClose: () => void;
  sourceName: string;
  /** Selectable target resources (the source itself is expected to be excluded by the caller). */
  options: SelectOptionType[];
  isLoading?: boolean;
  onConfirm: (targetUuids: string[]) => void;
};

export const DuplicateAvailabilityModal: FC<DuplicateAvailabilityModalProps> = ({
  isOpen,
  onClose,
  sourceName,
  options,
  isLoading,
  onConfirm,
}) => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState<SelectOptionType[]>([]);

  const handleClose = () => {
    setSelected([]);
    onClose();
  };

  const handleConfirm = () => {
    onConfirm(selected.map((option) => String(option.value)));
    setSelected([]);
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleClose}
      title={t('availability.duplicateModal.title')}
      width='s'
      hideFooter={false}
      footer={
        <ModalBottomButtons
          isLoading={isLoading}
          closeButton={{ callback: handleClose }}
          submitButton={{
            text: t('availability.duplicateModal.submit'),
            callback: handleConfirm,
            disabled: selected.length === 0 || isLoading,
          }}
        />
      }
    >
      <p>{t('availability.duplicateModal.hint', { name: sourceName })}</p>
      <Select
        menuPosition='fixed'
        isMulti
        isSearchable
        options={options}
        value={selected}
        onChange={(option) => setSelected([...(option as MultiValue<SelectOptionType>)])}
        name='duplicate-availability-targets'
        label={t('availability.duplicateModal.targetsLabel')}
      />
    </Modal>
  );
};
